export enum QRCodeRouteEnum {
  DIGITAL_MENU = "qr-code.digital-menu",
  DELIVERY_N_PICKUP = "qr-code.delivery-and-pickup",
}
